import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { LicenseResponse } from "api/controlPlaneApi";
import { fetchLicense } from "./licenseThunks";

export interface LicenseState {
  loadingLicense: boolean;
  licenseDetails: LicenseResponse | null;
}

const initialState: LicenseState = {
  loadingLicense: false,
  licenseDetails: null,
};

export const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    setLoadingLicense: (state, action: PayloadAction<boolean>) => {
      state.loadingLicense = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicense.fulfilled, (state, action) => {
        state.loadingLicense = false;
        state.licenseDetails = action.payload;
      })
      .addCase(fetchLicense.pending, (state) => {
        state.loadingLicense = true;
      })
      .addCase(fetchLicense.rejected, (state, action) => {
        state.loadingLicense = false;
        state.licenseDetails = null;
      });
  },
});

// Reducer actions
export const { setLoadingLicense } = licenseSlice.actions;

// Reducer selectors

export const licenseDetails = (state: RootState) =>
  state.license.licenseDetails;
export const loadingLicense = (state: RootState) =>
  state.license.loadingLicense;

export default licenseSlice.reducer;
